import { createCrudHooks } from './use-crud-factory'
import type { Testimonial } from '@/types/database.types'

/* ============================================================
   useTestimonials — PRD §8.6
   CRUD for testimonial records with active/inactive toggle.
   ============================================================ */

const {
  useList: useTestimonialList,
  useOne: useTestimonial,
  useCreate: useCreateTestimonial,
  useUpdate: useUpdateTestimonial,
  useDelete: useDeleteTestimonial,
} = createCrudHooks<Testimonial>({
  table: 'testimonials',
  queryKey: 'testimonials',
  orderBy: 'created_at',
  orderAsc: false,
})

export {
  useTestimonialList,
  useTestimonial,
  useCreateTestimonial,
  useUpdateTestimonial,
  useDeleteTestimonial,
}

export { useTestimonialList as useTestimonials }
